import { KICK_ANGLE, KICK_RANGE, MONSTER_ATTACK_ANGLE, MONSTER_ATTACK_RANGE } from '../config/GameConfig';
import { isInKickZone, isInMouthAttackZone, type Vec2Like } from '../utils/DirectionalMath';

export interface DirectionalActor {
  position: Vec2Like;
  yaw: number;
  defeated: boolean;
  attackRange?: number;
  attackAngle?: number;
}

export function canKick(monster: DirectionalActor, playerPosition: Vec2Like): boolean {
  return !monster.defeated && isInKickZone(monster.position, monster.yaw, playerPosition, KICK_RANGE, KICK_ANGLE);
}

export function mouthConnects(monster: DirectionalActor, playerPosition: Vec2Like): boolean {
  return !monster.defeated && isInMouthAttackZone(
    monster.position, monster.yaw, playerPosition,
    monster.attackRange ?? MONSTER_ATTACK_RANGE,
    monster.attackAngle ?? MONSTER_ATTACK_ANGLE,
  );
}

export class AttackCycle {
  private elapsed = 0;
  private connected = false;

  constructor(private readonly connectAt: number, readonly duration: number) {}

  update(deltaSeconds: number, monster: DirectionalActor, playerPosition: Vec2Like): 'waiting' | 'caught' | 'missed' {
    this.elapsed += deltaSeconds;
    if (!this.connected && this.elapsed >= this.connectAt) {
      this.connected = true;
      return mouthConnects(monster, playerPosition) ? 'caught' : 'missed';
    }
    return 'waiting';
  }

  get finished(): boolean { return this.elapsed >= this.duration; }
}
